import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/contexts/AuthContext";
import { apiGetNavPermissions, apiGetTenantConfig } from "@/lib/api";
import { isModuleEnabled, isNavigationVisible } from "@/lib/modules";

/** Use the existing tenant configuration and role visibility on every surface. */
export function useModuleAccess() {
  const { user } = useAuth();
  const config = useQuery({ queryKey: ["tenant-config"], queryFn: apiGetTenantConfig, staleTime: 60_000, enabled: !!user });
  const permissions = useQuery({ queryKey: ["nav-permissions"], queryFn: apiGetNavPermissions, staleTime: 60_000, enabled: !!user });
  const ready = config.isSuccess && permissions.isSuccess;
  const canAccess = (key: string) => ready && isModuleEnabled(config.data?.enabledModules, key)
    && isNavigationVisible(permissions.data ?? [], user, key);
  return { canAccess, ready, config: config.data, error: config.isError || permissions.isError, retry: () => { void config.refetch(); void permissions.refetch(); } };
}
